<template>
  <div class="form-inline suggestions">
    <div class="form-group">
      <select v-model="category" name="category" class="form-control">
        <option value="">--Select Category--</option>
        <option v-for="(category, catIndex) in populateOptions(1)" :value="category" :key="catIndex">
          {{category}}
        </option>
      </select>
    </div>
    <div class="form-group" v-show="category">
      <select v-model="subCategory" name="subcategory" class="form-control">
        <option value="">--Select SubCategory--</option>
        <option v-for="eachSubCategory in populateOptions(2)" :value="eachSubCategory" :key="eachSubCategory">
          {{eachSubCategory}}
        </option>
      </select>
    </div>
    <div class="form-group" v-show="subCategory && category">
      <select v-on:change="chooseDefaultLanguage()" v-model="topic" name="topics" class="form-control">
        <option value="">--Select Topics--</option>
        <option v-for="eachTopic in populateOptions(3)" :value="eachTopic" :key="eachTopic">
          {{eachTopic}}
        </option>
      </select>
    </div>
    <div class="form-group" v-show="subCategory && category && topic">
      <select v-on:change="chooseAReply()" v-model="language" name="language" class="form-control">
        <option value="">--Select Language--</option>
        <option value="eng">English</option>
        <option value="swa">Swahili</option>
        <option value="hi">Hindi</option>
      </select>
    </div>
  </div>
</template>
<script>
  import { mapState, mapActions } from 'vuex';

  export default {
    name: 'app-suggestion',
    data() {
      return {
        category: '',
        subCategory: '',
        topic: '',
        language: 'eng'
      };
    },
    methods: {
      populateOptions(level) {
        let options = [];
        if (level === 1) {
          options = Object.keys(this.replies);
        } else if (level === 2 && this.category) {
          options = Object.keys(this.replies[this.category]);
          if (!options.includes(this.subCategory)) {
            this.subCategory = '';
            this.topic = '';
          }
        } else if (level === 3 && this.subCategory) {
          options = Object.keys(this.replies[this.category][this.subCategory]);
          if (!options.includes(this.topic)) {
            this.topic = '';
          }
        }
        this.setFrequentlyUsedDetails({
          category: this.category,
          subCategory: this.subCategory,
          topic: this.topic
        });
        return options;
      },
      chooseAReply() {
        if (this.category && this.subCategory && this.topic && this.language) {
          try {
            const message = this.replies[this.category][this.subCategory][this.topic][this.language];
            this.$emit('setMessage', message);
          } catch (eror) {
            this.topic = '';
          }
        }
      },
      chooseDefaultLanguage() {
        this.language = 'eng';
        this.chooseAReply();
      },
      resetFields() {
        this.category = '';
        this.subCategory = '';
        this.topic = '';
      },
      ...mapActions(['setFrequentlyUsedDetails'])
    },
    computed: mapState({
      replies: state => state.general.commonReplies,
      frequentlyUsedDetails: state => state.general.frequentlyUsedDetails
    }),
    watch: {
      $route() {
        this.resetFields();
      },
      frequentlyUsedDetails() {
        if (Object.keys(this.frequentlyUsedDetails).length === 0) {
          this.resetFields();
        }
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/chat/suggestion.vue